import { useState } from "react";
import { template as tmpl } from "./template";
import _ from "lodash";
import { resetNewPassword } from "@/stores/apis/apiAuth";
import { REGEX_PASSWORD } from "@/config/constants";

const RetypePassword = ({ payload = {}, onRetypePasswordSuccess }) => {
	const [errors, setErrors] = useState({});
	const [password, setPassword] = useState("");
	const [confirmPassword, setConfirmPassword] = useState("");
	const [loading, setLoading] = useState(false);

	const validatePassword = () => {
		let errs = {};

		const regrex = new RegExp(REGEX_PASSWORD);
		if (!regrex.test(password.trim())) {
			errs.new_password =
				"Password must contain at least 8 characters, at least one uppercase letter, one lowercase letter, one number and special character.";
		}
		if (!password || !password.trim()) {
			errs.new_password = "Please enter new password.";
		}
		if (password !== confirmPassword) {
			errs.confirm_password = "Confirm password does not match";
		}

		let isValid = true;
		if (!_.isEmpty(errs)) {
			setErrors(errs);
			isValid = false;
		}

		return isValid;
	};

	const handleResetPassword = async () => {
		if (!validatePassword() || loading) return;
		setLoading(true);

		let data = { ...payload, password: password };
		const rs = await resetNewPassword(data);
		if (rs.success) {
			onRetypePasswordSuccess && onRetypePasswordSuccess();
		} else {
			let err = "Error occurs on trying to change new password";
			setErrors({ confirm_password: err });
		}

		setTimeout(() => {
			setLoading(false);
		}, 200);
	};

	const initProps = {
		loading: loading,
		errors: errors,
		setErrors: setErrors,
		payload: payload,
		password: password,
		confirmPassword: confirmPassword,
		setPassword: setPassword,
		setConfirmPassword: setConfirmPassword,
		handleResetPassword: handleResetPassword,
	};
	return tmpl && tmpl({ ...initProps });
};

export default RetypePassword;
